module.exports = __webpack_public_path__ + "img/campaigns_section.3fd21d5d.png";